import { LockOutlined } from "@ant-design/icons";
import { Form, InputNumber } from "antd";
import { isMaskedValue } from "common/Utility";
import SchemaFieldTitle from "../SchemaFieldTitle";
import Tooltip from "../Tooltip";

function FormFloatField({ fieldErrors, fieldId, name, description, max, min, isRequired, disabled = false, ...field }) {
    const fieldValue = Form.useWatch([fieldId]);
    const isMasked = isMaskedValue(fieldValue);
    const isDisabled = disabled || (field.isPII && isMasked);

    return (
        <Form.Item
            key={fieldId}
            name={[fieldId]}
            label={
                <div style={{ display: "flex", alignItems: "center" }}>
                    <SchemaFieldTitle name={name} tags={field.classifiers} orientation="horizontal" tagSummary={false} isPrimaryKey={field.isPrimaryKey} />
                    {field.isPII && (
                        <Tooltip title="Masked data due to PII restriction">
                            <LockOutlined style={{ marginLeft: 8, color: "#1890ff" }} />
                        </Tooltip>
                    )}
                </div>
            }
            tooltip={description}
            validateFirst={true}
            rules={[
                {
                    required: isRequired,
                    message: `Value is required`,
                },
                {
                    validator(_, value) {
                        if (value && value.toString().trim()) {
                            let floatValue = parseFloat(value);
                            if (isNaN(floatValue)) {
                                return Promise.reject(`Value should be a valid float value`);
                            }
                        }

                        return Promise.resolve();
                    },
                },
                {
                    type: "number",
                    min: min,
                    message: `Value should be greater than or equal to ${min}`,
                },
                {
                    type: "number",
                    max: max,
                    message: `Value should be less than or equal to ${max}`,
                },
            ]}
            {...fieldErrors}
        >
            <InputNumber min={min} max={max} precision={4} step={1} disabled={isDisabled} placeholder={isMasked ? "Masked" : undefined} />
        </Form.Item>
    );
}

export default FormFloatField;
